// Configuración compartida del Briefing del cliente.
// Usada tanto por el portal del cliente como por la ficha de Entrega de Servicios
// para garantizar que ambas vistas muestran y guardan exactamente lo mismo.

export const BRIEFING_STATUS = {
  pendiente: { label: 'Pendiente', color: 'bg-gray-100 text-gray-700 border-gray-300' },
  en_proceso: { label: 'En proceso', color: 'bg-amber-100 text-amber-700 border-amber-300' },
  completado: { label: 'Completado', color: 'bg-emerald-100 text-emerald-700 border-emerald-300' },
};

// type: 'text' | 'textarea' | 'select' | 'list' | 'table' | 'info'
export const BRIEFING_SECTIONS = [
  {
    key: 'info_basica',
    title: 'Información básica del negocio',
    fields: [
      { key: 'responsable', label: 'Nombre del responsable o CEO', type: 'text' },
      { key: 'razon_fiscal', label: 'Razón fiscal', type: 'text' },
      { key: 'direccion', label: 'Dirección del negocio', type: 'text' },
      { key: 'cif', label: 'CIF del titular', type: 'text' },
      { key: 'dni', label: 'DNI', type: 'text' },
      { key: 'email', label: 'Correo electrónico de contacto', type: 'text' },
      { key: 'telefono', label: 'Teléfono de contacto', type: 'text' },
      { key: 'forma_pago', label: 'Forma de pago', type: 'payment_link' },
    ],
  },
  {
    key: 'sobre_negocio',
    title: 'Sobre vuestro negocio',
    fields: [
      { key: 'historia', label: 'Contadnos la historia de vuestro negocio', type: 'textarea' },
      { key: 'organizacion', label: '¿Cómo está organizado internamente? (equipo, departamentos, turnos)', type: 'textarea' },
      { key: 'proposito', label: '¿Cuál es vuestro propósito? (el "para qué" existe el negocio)', type: 'textarea' },
      { key: 'mision', label: '¿Cuál es vuestra misión? (qué hacéis y cómo)', type: 'textarea' },
      { key: 'vision', label: '¿Y vuestra visión? (a dónde queréis llegar)', type: 'textarea' },
      { key: 'valores', label: '¿Cuáles son los valores que os definen?', type: 'textarea' },
      { key: 'transmitir', label: '¿Qué queréis transmitir a través del negocio?', type: 'textarea' },
      { key: 'propuesta_valor', label: '¿Cuál es vuestra propuesta de valor?', type: 'textarea' },
      { key: 'fortalezas_debilidades', label: 'Principales fortalezas y debilidades como empresa', type: 'textarea' },
      { key: 'lema', label: '¿Tenéis algún lema o frase que os represente?', type: 'text' },
      { key: 'trato_clientes', label: '¿Cómo tratáis a vuestros clientes?', type: 'textarea' },
      { key: 'premios', label: '¿Habéis recibido premios o reconocimientos?', type: 'textarea' },
      { key: 'enfoque_estrategico', label: '¿Cuál es vuestro enfoque estratégico a corto y largo plazo?', type: 'textarea' },
    ],
  },
  {
    key: 'objetivos',
    title: 'Objetivos',
    fields: [
      { key: 'por_que_redes', label: '¿Por qué queréis estar presentes en redes sociales?', type: 'textarea' },
      { key: 'objetivos', label: '¿Qué objetivos os gustaría conseguir?', type: 'textarea' },
      { key: 'redes_actuales', label: '¿En qué redes sociales estáis presentes actualmente?', type: 'textarea' },
      { key: 'datos_audiencia', label: '¿Qué datos tenéis sobre vuestra audiencia actual? (métricas)', type: 'textarea' },
      { key: 'contenido_actual', label: '¿Qué tipo de contenido estáis creando ahora mismo?', type: 'textarea' },
      { key: 'estrategia_previa', label: '¿Habéis trabajado con alguna estrategia de contenidos previa o tenéis algún documento a revisar?', type: 'textarea' },
      { key: 'meta_numerica', label: '¿Tenéis alguna meta numérica concreta?', type: 'textarea' },
    ],
  },
  {
    key: 'productos',
    title: 'Productos y servicios',
    fields: [
      { key: 'estrella', label: '¿Cuál es vuestro producto o servicio estrella?', type: 'textarea' },
      { key: 'listado', label: 'Enumerad todos los productos o servicios que ofrecéis', type: 'textarea' },
      { key: 'recursos', label: '¿Qué instalaciones, recursos o herramientas utilizáis?', type: 'textarea' },
      { key: 'mas_rentable', label: '¿Cuál es el producto o servicio más rentable?', type: 'textarea' },
      { key: 'potenciar', label: '¿Qué producto o servicio queréis potenciar ahora?', type: 'textarea' },
      { key: 'especial', label: '¿Qué lo hace especial?', type: 'textarea' },
      { key: 'mejor_competencia', label: '¿Por qué resuelve mejor las necesidades frente a la competencia?', type: 'textarea' },
    ],
  },
  {
    key: 'avatar',
    title: 'Cliente ideal / Avatar',
    fields: [
      { key: '_g1', label: 'Datos generales', type: 'info' },
      { key: 'edad', label: 'Edad aproximada', type: 'text' },
      { key: 'genero', label: 'Género', type: 'text' },
      { key: 'nivel_educativo', label: 'Nivel educativo', type: 'text' },
      { key: 'ocupacion', label: 'Ocupación', type: 'text' },
      { key: 'zona', label: 'Zona geográfica', type: 'text' },
      { key: 'producto_elige', label: '¿Qué producto o servicio suele elegir?', type: 'textarea' },
      { key: 'frecuencia', label: '¿Con qué frecuencia compra o contrata servicios como los vuestros?', type: 'text' },
      { key: '_g2', label: 'Intereses y estilo de vida', type: 'info' },
      { key: 'tiempo_libre', label: '¿Qué actividades le gusta hacer en su tiempo libre?', type: 'textarea' },
      { key: 'valores_empresa', label: '¿Qué valores tiene al elegir una empresa o proveedor?', type: 'textarea' },
      { key: 'motivacion', label: '¿Qué le motiva a elegir vuestro tipo de negocio?', type: 'textarea' },
      { key: '_g3', label: 'Problemas o necesidades', type: 'info' },
      { key: 'problemas', label: '¿Qué problemas o necesidades busca resolver? (indica el principal)', type: 'textarea' },
      { key: 'molestias', label: '¿Qué le molesta de otras experiencias con negocios similares?', type: 'textarea' },
      { key: 'valora', label: '¿Qué valora más cuando contrata o compra?', type: 'textarea' },
      { key: 'repetir', label: '¿Qué le haría repetir su experiencia con vosotros?', type: 'textarea' },
      { key: '_g4', label: 'Deseos y expectativas', type: 'info' },
      { key: 'espera_vivir', label: '¿Qué espera vivir o sentir durante su experiencia?', type: 'textarea' },
      { key: 'sentir_final', label: '¿Cómo se quiere sentir al final?', type: 'textarea' },
      { key: 'trato_espera', label: '¿Qué tipo de trato o atención espera recibir?', type: 'textarea' },
      { key: 'contenidos_conectan', label: '¿Qué contenidos o mensajes conectan mejor con él/ella en redes?', type: 'textarea' },
      { key: '_g5', label: 'Objeciones y barreras', type: 'info' },
      { key: 'dudas_miedos', label: '¿Qué dudas o miedos puede tener antes de comprar?', type: 'textarea' },
      { key: 'frenos', label: '¿Qué podría frenarle a elegir vuestro negocio?', type: 'textarea' },
      { key: 'busca_redes', label: '¿Qué busca en redes sociales antes de decidir?', type: 'textarea' },
      { key: 'confianza', label: '¿Qué haría que confiara en vosotros frente a la competencia?', type: 'textarea' },
    ],
  },
  {
    key: 'competencia',
    title: 'Competencia y referentes',
    fields: [
      { key: 'competidores_directos', label: 'Competidores directos (3 a 5)', type: 'list', placeholder: 'Nombre / web del competidor' },
      { key: 'inspiracion', label: 'Marcas o cuentas que os inspiran en redes (hasta 6)', type: 'list', placeholder: 'Marca / cuenta' },
      { key: 'competencia_indirecta', label: 'Negocios con público similar aunque vendan algo distinto (hasta 4)', type: 'list', placeholder: 'Negocio' },
    ],
  },
  {
    key: 'branding',
    title: 'Branding',
    fields: [
      { key: 'assets_marca', label: '¿Tenéis logo en alta calidad, tipografías, colores, manual de marca? Contádnoslo aquí.', type: 'textarea' },
      { key: 'archivos_branding', label: 'Subid aquí vuestros archivos de marca (logo, tipografías, manual de marca, paleta de colores...)', type: 'files' },
      { key: 'fotografias', label: '¿Tenéis fotografías profesionales del espacio, equipo o productos?', type: 'textarea' },
      { key: 'archivos_fotos', label: 'Subid aquí fotografías profesionales (si las tenéis)', type: 'files' },
      { key: 'web_actualizada', label: '¿Está vuestra web actualizada?', type: 'text' },
      { key: 'palabras_clave', label: 'Palabras clave que identifiquen vuestra marca', type: 'textarea' },
    ],
  },
  {
    key: 'crisis',
    title: 'Protocolo de crisis',
    fields: [
      { key: 'responsable_crisis', label: 'Persona responsable de contacto en caso de crisis en redes', type: 'text' },
    ],
  },
  {
    key: 'validacion',
    title: 'Contacto y validación de contenidos',
    fields: [
      { key: 'quien_aprueba', label: '¿Quién revisa y aprueba los contenidos antes de publicarlos?', type: 'text' },
    ],
  },
  {
    key: 'accesos',
    title: 'Accesos a redes sociales',
    fields: [
      { key: '_info', type: 'info', label: '🔒 Por seguridad, NO os pedimos aquí ninguna contraseña. Los accesos a vuestras redes (Facebook, Instagram, WordPress) los gestionaremos de forma segura por un canal aparte. Os enviaremos las instrucciones para compartirlos sin exponer vuestras credenciales.' },
    ],
  },
  {
    key: 'fechas',
    title: 'Fechas importantes',
    fields: [
      { key: 'fechas_importantes', label: 'Fechas del año importantes para el negocio', type: 'list', placeholder: 'Ej: 15 de marzo - Aniversario' },
      { key: 'campanas_clave', label: 'Campañas clave o momentos del calendario para planificar contenido', type: 'list', placeholder: 'Ej: Black Friday, Rebajas verano...' },
    ],
  },
  {
    key: 'equipo',
    title: 'Equipo y sus funciones',
    fields: [
      { key: 'miembros', label: 'Miembros del equipo', type: 'table', columns: ['Nombre', 'Función', 'Área de responsabilidad'] },
    ],
  },
  {
    key: 'briefing_ads',
    title: 'Briefing Ads',
    fields: [
      { key: '_info', type: 'info', label: 'Para gestionar tus campañas de publicidad necesitamos acceso a ciertos recursos. Comparte con nosotros las carpetas de Drive (creatividades, vídeos, catálogo de productos...) y márcalas en el checklist cuando estén compartidas.' },
      { key: 'invierte_ads', label: '¿Inviertes actualmente en publicidad (Meta / Google Ads)?', type: 'select', options: ['Sí, actualmente', 'No, nunca', 'Lo he hecho antes'] },
      { key: 'presupuesto_ads', label: 'Presupuesto mensual aproximado para Ads', type: 'text', placeholder: 'Ej: 500€/mes' },
      { key: 'objetivo_ads', label: 'Objetivo principal de la publicidad', type: 'textarea', placeholder: 'Ventas, leads, reconocimiento de marca...' },
      { key: 'carpetas_drive', label: 'Carpetas de Drive compartidas', type: 'drivelist' },
      { key: 'cuentas_publicitarias', label: 'Cuentas publicitarias / Business Manager (IDs o enlaces)', type: 'textarea' },
    ],
  },
];
